module.exports = __webpack_public_path__ + "static/media/img-head.1f819f7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-head.svg
// module id = 946
// module chunks = 0